import { type KnowledgeBuilderAssistantListItem } from "common";

export function getAssistantSourceFileNames(
  assistant: KnowledgeBuilderAssistantListItem
): string[] {
  const value = assistant.sourceFileNames ?? "";
  if (!value.trim()) return [];
  return value
    .split("\n")
    .map(v => v.trim())
    .filter(Boolean);
}

export function getWriteGroupIds(writeGroupId: string | null): number[] {
  if (!writeGroupId?.trim()) return [];
  return writeGroupId
    .split(",")
    .map(v => Number(v.trim()))
    .filter(v => Number.isFinite(v));
}
